export default __webpack_public_path__ + "static/redis-a1d343331fa59e840e31f1e4384162a8.png";